import { DEAL_KINDS, type DealKind } from '@carcheck/shared';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * AUT-633 — the kind chips of one step, one per `DEAL_KINDS` in its order
 * (five kinds; RULINGS 6). A chip the rules
 * keep closed is `disabled` — MUI marks it `aria-disabled`, the handler is
 * guarded again in `useStagesDraft` (RULINGS 22).
 */
export interface DealKindChipsProps {
  kinds: readonly string[];
  busy: boolean;
  canToggle: (kind: DealKind) => boolean;
  onToggle: (kind: DealKind) => void;
}

export const DealKindChips = ({
  kinds,
  busy,
  canToggle,
  onToggle,
}: DealKindChipsProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
      {DEAL_KINDS.map((kind) => {
        const on = kinds.includes(kind);
        return (
          <Chip
            key={kind}
            size="small"
            label={t(`config.dealKinds.${kind}`)}
            color={on ? 'primary' : 'default'}
            variant={on ? 'filled' : 'outlined'}
            aria-pressed={on}
            onClick={() => onToggle(kind)}
            disabled={busy || !canToggle(kind)}
          />
        );
      })}
    </Box>
  );
};
